import React from 'react';
import { Box } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import ConfirmAccessLoggedOut from 'pages/ConfirmAccess/ConfirmAccessLoggedOut';
import Login from '../pages/Login/Login';
import Register from '../pages/Login/components/Register/Register';
import ForgotPassword from '../pages/Login/components/ForgotPassword/ForgotPassword';
import Verify from '../pages/Login/components/Verify/Verify';
import ResetPassword from '../pages/Login/components/ResetPassword/ResetPassword';
import './LoggedOutRoutes.scss';

function LoggedInRoutes() {
  return (
    <Box id="login">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/confirm-access/:type/:id/:token/:accessType" element={<ConfirmAccessLoggedOut />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </Box>
  );
}

export default LoggedInRoutes;
